/**
 * Security Initialization
 * Sets up the security middleware with appropriate configuration
 */

import { securityMiddleware } from './securityMiddleware';
import { getSecurityConfig } from './securityConfig';

/**
 * Initialize security middleware with environment-specific configuration
 */
export const initializeSecurity = () => {
  const config = getSecurityConfig();
  securityMiddleware.configure(config);
};

/**
 * Security status check (for debugging)
 */
export const getSecurityStatus = () => {
  const metrics = securityMiddleware.getMetrics();
  return {
    ...metrics,
    environment: process.env.NODE_ENV || 'development',
    initialized: true,
  };
};

// Auto-initialize in non-test environments
if (process.env.NODE_ENV !== 'test') {
  initializeSecurity();
}
